export default {
 api_url : "https://apps.lienion.com"
 }
